import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PlayerRow from './PlayerRow';
import { customSortingByOrder } from '../../../../helpers/array';
import {
  getAccountAvatars,
  getCurrentClubApprovedMembers
} from '../../../../store/selectors';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const menuItems = ['wl', 'rake', 'lastLogin'];

const Members = () => {
  const { t } = useTranslation();
  // const {memberId: memberId} = useParams();
  const [isVisible, setIsVisible] = useState(false);
  const memberList = useSelector(getCurrentClubApprovedMembers);
  const avatarList = useSelector(getAccountAvatars);
  // const membersList = !!memberId ? memberList.filter(member => !['manager', 'agent'].includes(parameters.accountTypeIds[member.typeId]) && !member.isOwner) : memberList;
  const [completedMemberList, setCompletedMemberList] = useState(memberList);
  const [selectedField, setSelectField] = useState(menuItems[0]);
  const [order, setOrder] = useState('desc');
  const [search, setSearch] = useState('');

  const filteredMembersList = useMemo(
    () =>
      memberList.filter(
        m => !search || m.username.toLowerCase().includes(search.toLowerCase())
      ),
    [memberList, search]
  );

  useEffect(() => {
    setCompletedMemberList(filteredMembersList);
  }, [filteredMembersList]);

  const onChangeSearch = useCallback(e => {
    setSearch(e.target.value);
  }, []);

  const sortSelectedOrderList = () => {
    if (order.length > 0) {
      setCompletedMemberList(
        customSortingByOrder(memberList, order, selectedField)
      );
    }
  };

  const sortOrderList = i => {
    setSelectField(i);
    setOrder(order === 'asc' ? 'desc' : 'asc');
  };

  useEffect(() => {
    sortSelectedOrderList();
  }, [memberList]);

  useEffect(() => {
    sortSelectedOrderList();
  }, [order, selectedField]);

  return (
    <React.Fragment>
      <div className={`searchMember`}>
        <input onChange={onChangeSearch} />
        <span className={'searchIcon'}></span>
      </div>
      <div className={`memberCount`}>
        <span>
          {t('members')}({memberList.length})
        </span>
        <p className={'arrowIcon'}>
          <span>{t(selectedField)}</span>
          <FontAwesomeIcon
            icon={faChevronLeft}
            onClick={() => setIsVisible(true)}
            className="fa chevron-left"
          ></FontAwesomeIcon>
        </p>
      </div>
      {isVisible && (
        <div className={`mainDropdown ${isVisible && 'visible'}`}>
          <div className={`menuList memberDetail`}>
            {menuItems.map(item => (
              <React.Fragment key={item}>
                <div className={'menuItem'} onClick={() => sortOrderList(item)}>
                  <span className="selectedField">{t(item)}</span>
                  <div className="arrows">
                    <span
                      className={`up arrow ${selectedField === item &&
                        order === 'asc' &&
                        'active'}`}
                    ></span>
                    <span
                      className={`down arrow ${selectedField === item &&
                        order === 'desc' &&
                        'active'}`}
                    ></span>
                  </div>
                </div>
                <div className="separatorLine"></div>
              </React.Fragment>
            ))}
          </div>
          <div
            className={`transparentMask`}
            onClick={() => setIsVisible(false)}
          ></div>
        </div>
      )}
      <div className={`memberList filteredList`}>
        {completedMemberList.map(player => (
          <PlayerRow
            key={player._id}
            player={player}
            selectedField={selectedField}
            avatar={avatarList[player._id]}
          />
        ))}
      </div>
    </React.Fragment>
  );
};

export default Members;
